import React, { useState } from 'react';
import './index.scss';
import AuthenticateModal from '../../HomeDeliveryNew/AuthenticateModal';
import Input from '../../common/Input';
import { Errors } from '../../../constants/errors';
import _ from 'lodash';
import { validateMail } from '../../../services/Api/User/UserService';

const LoyaltyDLDBanner = ({
  drugName = '',
  isLoggedIn = false,
  loyaltyMemberBonus = 0
}) => {
  const [openSignupModal, setOpenSignupModal] = useState(false);
  const [emailData, setEmail] = useState({
    email: '',
    emailErr: '',
    emailKickboxErr: false
  });
  const { email, emailErr } = emailData;

  const handleError = (name, type) => {
    _.setError(setEmail, emailData, name, type);
  };

  const handleSignUpClick = async e => {
    e.preventDefault();
    if (!_.validateEmail(email)) {
      _.isEmpty(email.trim())
        ? handleError('email', 'Required')
        : handleError('email', 'Email');
      return;
    } else {
      handleError('email', '');
    }
    const responseData = await validateMail(email);
    if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
      setEmail({
        ...emailData,
        emailErr: Errors.Email,
        emailKickboxErr: true
      });
    } else {
      setOpenSignupModal(true);
    }
  };

  const handleCloseSignUpModal = () => {
    setOpenSignupModal(false);
  };

  const handleEmailChange = event => {
    const { value } = event.target;
    setEmail({
      ...emailData,
      email: value,
      emailKickboxErr: false
    });
  };

  const handleEmailBlur = event => {
    const { value } = event.target;
    let err = '';
    if (!_.validateEmail(value)) {
      err = _.isEmpty(value.trim()) ? Errors.Required : Errors.Email;
    }
    setEmail({
      ...emailData,
      email: value,
      emailErr: err,
      emailKickboxErr: false
    });
  };

  return (
    <div className="dldBannerContainer">
      <div
        className={`mainContainer ${isLoggedIn ? 'loginMainContainer' : ''}`}
      >
        <div className="container">
          <div className="leftSection">
            <div className="leftSectionContent">
              <span>
                <sup>$</sup>
                {loyaltyMemberBonus}
              </span>
              <p>Member Bonus</p>
            </div>
          </div>
          <div className="rightSection">
            <div className="drugTitle">
              <div className="drugName">Save even more on {drugName}</div>&nbsp;
              <div>as a SingleCare member!</div>
            </div>
            <div className="formWrapperMobile">
              <div className="termsAndConditionsPara desktop-only">
                Discount reflected below at select Pharmacies only. See{' '}
                <a
                  href="/terms-and-conditions"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Terms and Conditions.
                </a>
              </div>
              {!isLoggedIn && (
                <form className="formWrapper" autoComplete="on">
                  <Input
                    type="email"
                    name="email"
                    value={email}
                    placeholder="Enter your email"
                    handleInputChange={handleEmailChange}
                    handleInputBlur={handleEmailBlur}
                    error={emailErr}
                    autoComplete="email"
                  />
                  <button className="signUpButton" onClick={handleSignUpClick}>
                    Sign up
                  </button>
                </form>
              )}
              <div className="termsAndConditionsPara mobile-only">
                Discount reflected below at select Pharmacies only. See{' '}
                <a
                  href="/terms-and-conditions"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Terms and Conditions.
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openSignupModal && (
        <div className="mainModal">
          <div className="transparentBg" onClick={handleCloseSignUpModal}></div>
          <div className="signUpModal">
            <AuthenticateModal
              hideAuthenticateModal={handleCloseSignUpModal}
              emailFromDLDBanner={email}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoyaltyDLDBanner;
